import { styled, Paper } from '@mui/material';

export const AuthCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: 400,
}));
